import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  background-color: #F1F3F8;
  width: 100%;
  height: 56px;
  z-index: 99;

  ${props => props.theme.isLarge && `
    position: sticky;
    top: 105px;
  `};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
  `};
  ${props => props.theme.isLarge && `
    width: 85%;
  `};
  ${props => props.theme.isXLarge && `
    width: 953px;
  `};
  ${props => props.theme.isXXLarge && `
    width: 1200px;
  `};
`;

const Items = styled.div`
  width: 296px;
  height: 100%;
  border-bottom: 1px solid #D7DFE7;
  display: flex;
  align-items: flex-end;
`;

const Item = styled.a`
  text-transform: uppercase;
  width: 119px;
  height: 34px;
  margin-bottom: -1px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font: ${props => props.theme.fontWeightHeavy} 15px/17px ${props => props.theme.fontFamilyBody};
  color: ${props => (props.isActive ? props.theme.bodyColor : '#627484')};

  &:hover {
    text-decoration: none !important;
    color: ${props => (props.isActive ? props.theme.bodyColor : props.theme.bodyColor)};
  }

  &:after {
    content: "";
    display: inline-block;
    height: 0px;
    width: 100%;
    border-bottom: 3px solid ${props => (props.isActive ? props.theme.primaryColor : 'transparent')};
  }
`;

const menus = ['performance', 'audience'];

export default function Nav({ active }) {
  return (
    <Container>
      <Wrapper>
        <Items>
          {menus.map(menu => (
            <Item key={menu} href={`/analytics/${menu}`} isActive={active === menu}>{menu}</Item>
          ))}
        </Items>
      </Wrapper>
    </Container>
  );
}

Nav.propTypes = { active: PropTypes.oneOf(menus).isRequired };
